// NPM Modules
import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import Leg from '@/Models/Leg';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	let meta;

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getLegsForSelection(selectionId, pagination = null, sorting = null) {
			const leg = new Leg();
			return leg
				.racingSelections(selectionId, pagination, sorting)
				.then((result) => {
					meta = result.meta;
					set(collect(result.data));
				})
				.catch((e) => {
					console.error(e);
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
